import React from "react";
import { Link } from "react-router";
import axios from "axios";
import Dialog from "rc-dialog";
import Select from "react-select";
import SelectNew from "react-select-new";
import classNames from "classnames";
import FormErrorHandler from "../../components/FormErrorHandler";
import { downloadFile, smoothScrollToTop } from "../../functions.js";
import debounce from "debounce-promise";
import { DontShowProgressAutomaticallyToolTip } from "../courses/components/tooltips";

export default class UsersForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            editMode: props.params.itemID !== undefined,
            errorMessage: {},
            name: "",
            eol_id: "",
            eol_relation_code: "",
            account_manager: null,
            city: "",
            postcode: "",
            address: [],
            is_active: true,
            is_employer: false,
            authorized_users: [],
            connected_users: [],
            eol_persons_loading: false,
            eol_persons: [],
            eol_person_selected: false,
            eol_existing_person: null,
            addContactPersonVisible: false,
            send_progress: false,
            phone_number: null,
            postal_address: null,
            postal_address_city: null,
            postal_address_country: null,
            postal_address_zipcode: null
        };
    }

    updateElementState = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    };

    downloadExport = (e) => {
        e.preventDefault();

        downloadFile(`/v1/reports/trainer-students/?trainer=${this.props.params.itemID}`);
    };

    loadEOLOptions = (url, val) => {
        return axios
            .get(url + val)
            .then((response) => {
                return {
                    options: response.data.map((item) => {
                        return {
                            value: item.eol_id,
                            label: `${item.eol_relation_code} - ${item.name} (${item.metadata.address.join(", ")}, ${item.metadata.city}) ${
                                item.is_active == 0 ? "[inactief]" : ""
                            }`
                        };
                    })
                };
            })
            .catch((error) => {
                console.log(error);
            });
    };

    loadEOLOptionsDebounced = debounce(this.loadEOLOptions, 500);

    handleOptionsChange = (val, stateName) => {
        if (Array.isArray(val)) {
            this.setState({
                [stateName]: val.map((option) => {
                    return option.value;
                })
            });
        } else {
            this.setState({
                [stateName]: val
            });
        }
    };

    makePrimaryContactPerson = (userAuthUUID, userName) => {
        if (confirm(`Wilt je ${userName} de primaire contactpersoon maken?`)) {
            axios
                .patch(`/v1/trainers/${this.props.params.itemID}/user_authorizations/${userAuthUUID}/`, {
                    is_trainer_contact: true,
                    is_primary_trainer_contact: true
                })
                .then((response) => {
                    this.getAllResults();
                })
                .catch((error) => {
                    this.setState({
                        errorMessage: error.response.data
                    });
                });
        }
    };

    getAllResults = () => {
        if (this.state.editMode) {
            axios
                .all([
                    axios.get("/v1/trainers/" + this.props.params.itemID + "/"),
                    axios.get(
                        "/v1/trainers/" +
                            this.props.params.itemID +
                            "/users/?pagination=false&fields=uuid,nibhv_number,roles,email,is_active,full_name,is_active,is_trainer_contact,is_primary_trainer_contact"
                    ),
                    axios.get(
                        "/v1/trainers/" +
                            this.props.params.itemID +
                            "/user_authorizations/?pagination=false&fields=user,uuid,is_trainer_contact,is_primary_trainer_contact"
                    )
                ])
                .then(
                    axios.spread((trainer, users, authorizations) => {
                        if (trainer.data.eol_id !== null) {
                            this.setState({
                                name: trainer.data.name,
                                uuid: trainer.data.uuid,
                                eol_id: trainer.data.eol_id,
                                eol_relation_code: trainer.data.eol_relation_code,
                                account_manager: trainer.data.account_manager,
                                city: trainer.data.city,
                                postcode: trainer.data.postcode,
                                address: trainer.data.address,
                                is_active: trainer.data.is_active,
                                is_employer: trainer.data.is_employer,
                                authorized_users: trainer.data.authorized_users,
                                addContactPersonVisible: false,
                                connected_users: users.data,
                                user_authorizations: authorizations.data,
                                eol_person_selected: "",
                                send_progress: trainer.data.send_progress,
                                phone_number: trainer.data.phone,
                                postal_address: trainer.data.postal_address,
                                postal_address_city: trainer.data.postal_address_city,
                                postal_address_country: trainer.data.postal_address_country,
                                postal_address_zipcode: trainer.data.postal_address_zipcode
                            });
                        } else {
                            // There was no Exact Online ID found, we have no sub data
                            this.setState({
                                name: trainer.data.name,
                                uuid: trainer.data.uuid,
                                address: ["-"],
                                eol_relation_code: "Dit bedrijf is niet gekoppeld met Exact",
                                is_active: trainer.data.is_active,
                                is_employer: trainer.data.is_employer,
                                authorized_users: trainer.data.authorized_users,
                                addContactPersonVisible: false,
                                eol_person_selected: "",
                                send_progress: trainer.data.send_progress
                            });
                        }
                    })
                )
                .catch((error) => {
                    console.log(error);
                });
        }
    };

    demoteItem = (user) => {
        const auth = this.state.user_authorizations.find((auth) => auth.user === user.uuid);

        return axios
            .patch(`/v1/trainers/${this.props.params.itemID}/user_authorizations/${auth.uuid}/`, {
                is_trainer_contact: false
            })
            .then((response) => {
                this.props.addGlobalMessage({
                    title: `De contactpersoon '${user.full_name}' is succesvol ontkoppeld`
                });
                this.getAllResults();
            })
            .catch((error) => {
                console.log(error);
            });
    };

    deleteItem = (user, replacement) => {
        const auth = this.state.user_authorizations.find((auth) => auth.user === user.uuid);

        const config = {};
        if (replacement) {
            // if we have a replacement, add it as data to our DELETE request:
            config["data"] = {
                replacement_user: replacement
            };
        }

        return axios
            .delete(`/v1/trainers/${this.props.params.itemID}/user_authorizations/${auth.uuid}/`, config)
            .then((response) => {
                this.props.addGlobalMessage({
                    title: `De contactpersoon '${user.full_name}' is succesvol ontkoppeld`
                });
                this.getAllResults();
            })
            .catch((error) => {
                console.log(error);
            });
    };

    addContactPerson = () => {
        this.setState({
            eol_persons: [],
            eol_persons_loading: true,
            addContactPersonVisible: true,
            eol_person_selected: false
        });

        axios
            .get("/v1/crm/contacts/?account=" + this.state.eol_id)
            .then((response) => {
                let contactUsers = [];
                response.data.forEach((item) => {
                    let foundUser = this.state.connected_users.find((user) => user.email === item.email);
                    let connectedUser = this.state.connected_users.find((user) => user.email === item.email && user.is_trainer_contact);
                    if (!connectedUser) {
                        if (foundUser) {
                            contactUsers.push({
                                ...item,
                                roles: foundUser.roles
                            });
                        } else {
                            contactUsers.push({
                                ...item,
                                roles: []
                            });
                        }
                    }
                });

                this.setState({
                    eol_persons: contactUsers,
                    addContactPersonVisible: true,
                    eol_persons_loading: false
                });

                this.changeContactPerson();
            })
            .catch((error) => {
                this.setState({
                    errorMessage: error.response.data
                });
            });
    };

    saveContactPerson = () => {
        let eolPerson = this.state.eol_persons.find((item) => item.eol_id == this.state.eol_person_selected);
        this.setState({
            eol_person_selected: false,
            addContactPersonVisible: false
        });

        // Check if we have a record of the user
        let userAuth = false;
        if (eolPerson.user && eolPerson.user.uuid) {
            userAuth = this.state.user_authorizations.find((auth) => auth.user == eolPerson.user.uuid);
        }

        // If the persons exists, update the known record
        if (eolPerson.eol_id !== null && eolPerson.user !== null && userAuth) {
            // We found a combo of this user and this trainer
            let authData = {
                is_trainer_contact: true
            };

            if (userAuth) {
                axios
                    .patch(`/v1/trainers/${this.props.params.itemID}/user_authorizations/${userAuth.uuid}/`, authData)
                    .then((response) => {
                        this.getAllResults();
                    })
                    .catch((error) => {
                        this.setState({
                            errorMessage: error.response.data
                        });
                        console.log(error);
                    });
            }
        } else if (eolPerson && eolPerson.user !== null) {
            // No userAuth known for this combination of user and trainer
            let authData = {
                user: eolPerson.user.uuid,
                is_trainer_contact: true
            };

            axios
                .post("/v1/trainers/" + this.props.params.itemID + "/user_authorizations/", authData)
                .then((response) => {
                    this.getAllResults();
                })
                .catch((error) => {
                    this.setState({
                        errorMessage: error.response.data
                    });
                    console.log(error);
                });
        } else {
            // This person does not yet eist, create it and make authorization
            let roles = ["student"];
            if (eolPerson.roles) {
                roles = eolPerson.roles;
            }
            if (!roles.includes("trainer-contact")) {
                roles.push("trainer-contact");
            }

            let postData = {
                eol_id: eolPerson.eol_id,
                initials: eolPerson.initials,
                first_name: eolPerson.first_name,
                last_name: eolPerson.last_name,
                last_name_prefix: eolPerson.last_name_prefix,
                email: eolPerson.email,
                roles: roles,
                is_active: true
            };

            // #1008 - Added send_email=true
            axios
                .post("/v1/users/?send_email=true", postData)
                .then((response) => {
                    this.props.addGlobalMessage({
                        title: `De gebruiker met e-mailadres '${response.data.email}' is succesvol opgeslagen`,
                        link: false
                    });

                    let authData = {
                        user: response.data.uuid,
                        is_trainer_contact: true
                    };
                    axios
                        .post("/v1/trainers/" + this.props.params.itemID + "/user_authorizations/", authData)
                        .then((response) => {
                            this.getAllResults();
                        })
                        .catch((error) => {
                            this.setState({
                                errorMessage: error.response.data
                            });
                            console.log(error);
                        });
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    };

    hideContactPerson = () => {
        this.setState({
            addContactPersonVisible: false
        });
    };

    changeContactPerson = (e) => {
        let eolPersonSelected = this.state.eol_person_selected;
        if (e && e.target && e.target.value !== false && e.target.value !== "") {
            eolPersonSelected = e.target.value;
        }

        let eolPerson = this.state.eol_persons.find((item) => item.eol_id == eolPersonSelected);
        if (eolPerson) {
            this.setState({
                eol_existing_person: eolPerson.user,
                eol_person_selected: eolPersonSelected
            });
        } else {
            this.setState({
                eol_existing_person: null,
                eol_person_selected: false
            });
        }
    };

    handleSubmit = (e) => {
        e.preventDefault();

        if (!this.state.editMode) {
            let postData = {
                eol_id: this.state.eol_id.value
            };

            axios
                .post("/v1/trainers/", postData)
                .then((response) => {
                    this.props.addGlobalMessage({
                        title: `De opleider '${response.data.name}' is succesvol opgeslagen`,
                        link: `/trainers/edit/${response.data.uuid}`
                    });
                    this.props.router.push("/trainers");
                })
                .catch((error) => {
                    this.setState({
                        errorMessage: error.response.data
                    });
                    console.log(error);
                });
        }
    };

    componentDidMount() {
        this.getAllResults();
    }

    toggleItem = (e, itemID, itemName, currentStatus) => {
        let description = `Automatisch tonen van voortgang is geactiveerd`;

        if (currentStatus) {
            // Current status is true, so we toggle to false
            let question = `Weet je zeker dat je de cursisten voortgang tijdens de cursus niet vrij wilt geven?`;
            description = `Het automatisch tonen van voortgang is gedeactiveerd`;

            if (confirm(question)) {
                axios
                    .patch("/v1/trainers/" + itemID + "/", {
                        send_progress: !currentStatus
                    })
                    .then((response) => {
                        this.props.addGlobalMessage({
                            title: description,
                            link: `/trainers/edit/${itemID}`
                        });
                        this.getAllResults();
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        } else {
            axios
                .patch("/v1/trainers/" + itemID + "/", {
                    send_progress: !currentStatus
                })
                .then((response) => {
                    this.props.addGlobalMessage({
                        title: description,
                        link: `/trainers/edit/${itemID}`
                    });
                    this.getAllResults();
                })
                .catch((error) => {
                    console.log(error);
                });
        }
        smoothScrollToTop(600);
    };

    formatPostalAddress = () => {
        const { postal_address, postal_address_zipcode, postal_address_city, postal_address_country } = this.state;
        const addressParts = [];

        if (postal_address) {
            addressParts.push(
                <div key="address">
                    {postal_address}
                    <br />
                </div>
            );
        }
        if (postal_address_zipcode || postal_address_city) {
            addressParts.push(
                <div key="zipcode_city">
                    {postal_address_zipcode} {postal_address_city}
                    <br />
                </div>
            );
        }
        if (postal_address_country) {
            addressParts.push(
                <div key="country">
                    {postal_address_country}
                    <br />
                </div>
            );
        }

        return addressParts;
    };

    isPostalAddressAvailable = () => {
        const { postal_address, postal_address_zipcode, postal_address_city, postal_address_country } = this.state;
        return postal_address || postal_address_zipcode || postal_address_city || postal_address_country;
    };

    render() {
        const user = this.props.authentication?.user;
        let userRoles = user?.roles || [];
        let addContactPersonButton = "";

        // Check if the current user can add contactpersons
        if (userRoles.find((role) => ["certification"].includes(role))) {
            addContactPersonButton = (
                <div className="section-buttons">
                    <Link onClick={() => this.addContactPerson()} className="btn btn-primary">
                        Contactpersoon toevoegen
                    </Link>
                </div>
            );
        }

        let formContent = "";
        if (this.state.name === "" && this.state.editMode) {
            formContent = (
                <div>
                    <h2>Ophalen van de gegevens...</h2>

                    <div className="form-group text-center">
                        <Link to="/trainers" className="btn btn-light">
                            Terug naar het overzicht
                        </Link>
                    </div>
                </div>
            );
        } else if (!this.state.editMode) {
            // Add new item
            formContent = (
                <div className="form-group">
                    <label>
                        Zoek naar opleiders <span>* gebruik minimaal 3 karakters om te zoeken</span>
                    </label>
                    <Select.Async
                        {...window.selectDefaults}
                        name="authorities"
                        tabIndex="4"
                        value={this.state.eol_id}
                        loadOptions={(val) => this.loadEOLOptionsDebounced("/v1/crm/companies/?search=", val)}
                        onChange={(val) => this.handleOptionsChange(val, "eol_id")}
                        multi={false}
                        ignoreAccents={false}
                        autofocus={true}
                        autoload={false}
                        cache={false}
                        placeholder="Typ om te zoeken"
                        closeOnSelect={true}
                    />
                    <FormErrorHandler fieldName="all" errorObject={this.state.errorMessage} />

                    <FormErrorHandler fieldName="non_field_errors" errorObject={this.state.errorMessage} />
                </div>
            );
        } else {
            // Edit/view an item
            let userContactpersonRows = [];
            let userInstructorRows = [];
            let primaryContact = "-";
            if (this.state.connected_users !== false) {
                this.state.connected_users.forEach((user) => {
                    let contactPerson = this.state.authorized_users.find((item) => item.user == user.uuid);
                    let auth = this.state.user_authorizations.find((item) => item.user == user.uuid);

                    if (auth.is_primary_trainer_contact) {
                        primaryContact = user.full_name;
                    }

                    let userRoleDescription = [];
                    if (user.is_active && contactPerson) {
                        const isInstructor = user.roles.some((role) => role === "instructor");
                        if (isInstructor) {
                            userRoleDescription.push("Instructeur");
                        }
                        if (contactPerson && auth.is_primary_trainer_contact) {
                            userRoleDescription.push("Primair contactpersoon");
                        }
                        if (contactPerson && contactPerson.is_trainer_contact && !auth.is_primary_trainer_contact) {
                            userRoleDescription.push("Contactpersoon");
                        }

                        let userActions = [];
                        if (userRoles.find((role) => ["certification"].includes(role))) {
                            // Disabled this, because this should be done via the EOL connection
                            // Details in EOL should be filled out before we can do this
                            if ((contactPerson.is_instructor && contactPerson.is_trainer_contact) || contactPerson.is_trainer_contact) {
                                userActions.push(
                                    <span
                                        key={auth.uuid + "demote"}
                                        className="text-link"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            this.setState({ demoteTrainerContact: user });
                                        }}
                                    >
                                        Contactpersoon verwijderen
                                        <br />
                                    </span>
                                );
                            } else {
                                userActions.push(
                                    <span
                                        key={auth.uuid + "delete"}
                                        className="text-link"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            this.setState({ deleteTrainerContact: user });
                                        }}
                                    >
                                        Instructeur verwijderen
                                        <br />
                                    </span>
                                );
                            }
                            if (!contactPerson.is_primary_trainer_contact && contactPerson.is_trainer_contact) {
                                userActions.push(
                                    <span
                                        key={auth.uuid + "promote"}
                                        className="text-link"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            this.makePrimaryContactPerson(auth.uuid, user.full_name);
                                        }}
                                    >
                                        Primair contactpersoon maken
                                    </span>
                                );
                            }
                        }

                        if (contactPerson.is_trainer_contact) {
                            userContactpersonRows.push(
                                <tr key={user.uuid} className={classNames({ inactive: !user.is_active })}>
                                    <td width="140">{user.nibhv_number}</td>
                                    <td>
                                        {user.full_name}
                                        <br />
                                        <span className="lighter">{userRoleDescription.join(" / ")}</span>
                                    </td>
                                    <td>
                                        <a href={"mailto:" + user.email}>{user.email}</a>
                                    </td>
                                    {userActions.length > 0 ? <td>{userActions}</td> : false}
                                </tr>
                            );
                        }

                        if (isInstructor) {
                            userInstructorRows.push(
                                <tr key={user.uuid} className={classNames({ inactive: !user.is_active })}>
                                    <td width="140">{user.nibhv_number}</td>
                                    <td>
                                        {user.full_name}
                                        <br />
                                        <span className="lighter">{userRoleDescription.join(" / ")}</span>
                                    </td>
                                    <td>
                                        <a href={"mailto:" + user.email}>{user.email}</a>
                                    </td>
                                    {userActions.length > 0 ? <td>{userActions}</td> : false}
                                </tr>
                            );
                        }
                    }
                });
            } else {
                userContactpersonRows.push(
                    <tr key={user.uuid}>
                        <td colSpan="3">Ophalen van contactpersonen...</td>
                    </tr>
                );
                userInstructorRows.push(
                    <tr key={user.uuid}>
                        <td colSpan="3">Ophalen van contactpersonen...</td>
                    </tr>
                );
            }

            let activateItem = (
                <i
                    className="fa fa-toggle-on"
                    title="Deactiveren"
                    onClick={(e) => {
                        e.stopPropagation();
                        this.toggleItem(e, this.state.uuid, this.state.name, this.state.send_progress);
                    }}
                ></i>
            );
            if (!this.state.send_progress) {
                activateItem = (
                    <i
                        className="fa fa-toggle-off"
                        title="Activeren"
                        onClick={(e) => {
                            e.stopPropagation();
                            this.toggleItem(e, this.state.uuid, this.state.name, this.state.send_progress);
                        }}
                    ></i>
                );
            }

            formContent = (
                <div>
                    <h2>{this.state.name}</h2>
                    <div className="row">
                        <div className="col-3">
                            <p>Exact Online relatienummer</p>
                        </div>
                        <div className="col-9">{this.state.eol_relation_code || "-"}</div>
                    </div>
                    <div className="row">
                        <div className="col-3">
                            <p>Telefoonnummer</p>
                        </div>
                        <div className="col-9">{this.state.phone_number}</div>
                    </div>
                    <div className="row">
                        <div className="col-3">
                            <p>Adresgegevens</p>
                        </div>
                        <div className="col-9">
                            <p>
                                {this.state.address !== null ? this.state.address : "-"}
                                <br />
                                {this.state.postcode} {this.state.city}
                            </p>
                        </div>
                    </div>
                    {this.isPostalAddressAvailable() && (
                        <div className="row">
                            <div className="col-3">
                                <p>Postadresgegevens</p>
                            </div>
                            <div className="col-9">
                                <div>{this.formatPostalAddress()}</div>
                            </div>
                        </div>
                    )}
                    <div className="row">
                        <div className="col-3">
                            <p>Primair contactpersoon</p>
                        </div>
                        <div className="col-9">
                            <p>{primaryContact}</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-3">
                            <p>Actief</p>
                        </div>
                        <div className="col-9">{this.state.is_active ? "Ja" : "Nee"}</div>
                    </div>

                    <div className="row">
                        <div className="col-3">
                            <p>
                                Toon tijdens cursus cursist voortgang in Mijn NIBHV
                                <DontShowProgressAutomaticallyToolTip />
                            </p>
                        </div>
                        <div className="col-9">
                            <div className={"header-account-menu__icon trainer_toggle"}>{activateItem}</div>
                        </div>
                    </div>

                    <div className="section-top">
                        <h2>Contactpersonen</h2>
                        {addContactPersonButton}
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th>NIBHV-nummer</th>
                                        <th>Naam</th>
                                        <th>E-mail adres</th>
                                        {userRoles.find((role) => ["certification"].includes(role)) ? <th width="240">Actie</th> : false}
                                    </tr>
                                </thead>
                                <tbody>{userContactpersonRows}</tbody>
                            </table>
                        </div>
                    </div>

                    <div className="section-top">
                        <h2>Instructeurs</h2>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th>NIBHV-nummer</th>
                                        <th>Naam</th>
                                        <th>E-mail adres</th>
                                        {userRoles.find((role) => ["certification"].includes(role)) ? <th width="240">Actie</th> : false}
                                    </tr>
                                </thead>
                                <tbody>{userInstructorRows}</tbody>
                            </table>
                        </div>
                    </div>
                </div>
            );
        }

        let newContactPersonContent = "";
        let eolPerson = [];
        let eolDivision = "1826261";
        if (APP_CONFIG.environment !== "development") {
            eolDivision = "875515";
        }
        if (this.state.eol_person_selected !== false && this.state.eol_person_selected != "") {
            eolPerson = this.state.eol_persons.find((item) => item.eol_id == this.state.eol_person_selected);

            let accountExists = "";
            if (eolPerson.user !== null) {
                accountExists = (
                    <div>
                        <p>Deze persoon heeft al een account in dit systeem:</p>

                        {eolPerson.user !== null && eolPerson.user.eol_id !== null ? (
                            <div className="alert alert-danger">
                                Er is al een persoon met dit e-mail adres gekoppeld aan een persoon in Exact Online. Een persoon kan maar met 1 persoon in Exact Online
                                gekoppeld worden.
                                <br />
                                <a
                                    href={
                                        "https://start.exactonline.nl/docs/CRMContactCard.aspx?_ID=%7b" + this.state.eol_person_selected + "%7d&_Division_=" + eolDivision
                                    }
                                    target="_blank"
                                >
                                    Pas het e-mail adres aan in Exact Online
                                </a>
                                .
                            </div>
                        ) : (
                            false
                        )}

                        <div className="row mt-2">
                            <div className="col-4">
                                <strong>Voorletters</strong>
                            </div>
                            <div className="col-8">{eolPerson.user.initials || "-"}</div>
                        </div>
                        <div className="row">
                            <div className="col-4">
                                <strong>Voornaam</strong>
                            </div>
                            <div className="col-8">{eolPerson.user.first_name || "-"}</div>
                        </div>
                        <div className="row">
                            <div className="col-4">
                                <strong>Tussenvoegsel</strong>
                            </div>
                            <div className="col-8">{eolPerson.user.last_name_prefix || "-"}</div>
                        </div>
                        <div className="row">
                            <div className="col-4">
                                <strong>Achternaam</strong>
                            </div>
                            <div className="col-8">{eolPerson.user.last_name || "-"}</div>
                        </div>
                        <div className="row">
                            <div className="col-4">
                                <strong>E-mail</strong>
                            </div>
                            <div className="col-8">{eolPerson.user.email || "-"}</div>
                        </div>
                    </div>
                );
            }

            let existingAccount = "";
            if (accountExists == "" || (eolPerson.user && eolPerson.user.eol_id == null)) {
                existingAccount = (
                    <div>
                        {accountExists != "" ? <hr /> : ""}
                        <p>Dit account wordt bijgewerkt met de volgende gegevens vanuit Exact Online.</p>
                        <div className="row mt-2">
                            <div className="col-4">
                                <strong>Voorletters</strong>
                            </div>
                            <div className="col-8">{eolPerson.initials || "-"}</div>
                        </div>
                        <div className="row">
                            <div className="col-4">
                                <strong>Voornaam</strong>
                            </div>
                            <div className="col-8">{eolPerson.first_name || "-"}</div>
                        </div>
                        <div className="row">
                            <div className="col-4">
                                <strong>Tussenvoegsel</strong>
                            </div>
                            <div className="col-8">{eolPerson.last_name_prefix || "-"}</div>
                        </div>
                        <div className="row">
                            <div className="col-4">
                                <strong>Achternaam</strong>
                            </div>
                            <div className="col-8">{eolPerson.last_name || "-"}</div>
                        </div>
                        <div className="row">
                            <div className="col-4">
                                <strong>E-mail</strong>
                            </div>
                            <div className="col-8">{eolPerson.email || "-"}</div>
                        </div>
                    </div>
                );
            }

            newContactPersonContent = (
                <div key="newcontactpersoncontent">
                    {accountExists}
                    {existingAccount}
                </div>
            );
        }

        let eolPersonsContent = [];
        if (this.state.eol_persons.length > 0) {
            this.state.eol_persons.forEach((person) => {
                if (!this.state.connected_users.find((p) => p.email == person.email && p.is_trainer_contact)) {
                    let checkIncomplete = true;
                    if (person.initials && person.first_name && person.last_name && person.email) {
                        checkIncomplete = false;
                    }

                    eolPersonsContent.push(
                        <option value={person.eol_id} key={person.eol_id}>
                            {checkIncomplete ? "[incompleet] " : ""}
                            {person.initials ? person.initials : false}
                            {person.first_name ? "(" + person.first_name + ") " : false}
                            {person.last_name_prefix ? person.last_name_prefix + " " : false}
                            {person.last_name ? person.last_name : false}
                            {person.email ? " (" + person.email + ")" : false}
                        </option>
                    );
                }
            });
        }

        let footerModalButtons = [];
        let checkIncomplete = true;
        if ((eolPerson.initials && eolPerson.first_name && eolPerson.last_name && eolPerson.email && eolPerson.user == null) || eolPerson.user) {
            checkIncomplete = false;
            footerModalButtons.push(
                <button type="button" className="btn btn-primary" key="yes" onClick={this.saveContactPerson}>
                    Aanmaken/koppelen
                </button>
            );
        }
        // If no person is selected also hide the message and link
        if (this.state.eol_person_selected == false || this.state.eol_person_selected == "") {
            checkIncomplete = false;
        }

        let invoiceAllowed = userRoles.find((role) => ["certification", "development-and-advice", "trainer-contact"].includes(role));
        let eolPersonLink = "https://start.exactonline.nl/docs/CRMContactCard.aspx?_ID=%7b" + this.state.eol_person_selected + "%7d&_Division_=" + eolDivision;

        return (
            <div>
                <div className="section-top">
                    <div className="breadcrumbs">
                        <Link to={"/trainers"}>Opleiders</Link>
                    </div>
                    <h1>Opleider {this.state.editMode ? "details" : "toevoegen"}</h1>
                    <div className="section-buttons">
                        {this.state.editMode && invoiceAllowed && this.state.name !== "" ? (
                            <Link to={`/invoices/view/${this.props.params.itemID}`} className="btn btn-primary">
                                Bekijk alle facturen
                            </Link>
                        ) : (
                            false
                        )}
                        <a className="btn btn-secondary" href="#" onClick={(e) => this.downloadExport(e)}>
                            Download overzicht oude/nieuwe NIBHV nummers
                        </a>
                    </div>
                </div>

                <form onSubmit={this.handleSubmit} ref="formref">
                    <div className="row">
                        <div className="col-12">{formContent}</div>
                    </div>

                    <div className="form-group text-center">
                        <Link to="/trainers" className="btn btn-light">
                            Terug naar het overzicht
                        </Link>
                        {!this.state.editMode ? (
                            <button className="btn btn-primary" type="submit">
                                Opslaan
                            </button>
                        ) : (
                            false
                        )}
                    </div>
                </form>

                <Dialog
                    title="Contactpersoon toevoegen"
                    onClose={() => this.setState({ addContactPersonVisible: false })}
                    visible={this.state.addContactPersonVisible}
                    width={480}
                    footer={footerModalButtons}
                >
                    <form method="post" onSubmit={this.createStudent}>
                        <div className="row mt-2 mb-2">
                            <div className="col-12">
                                <label>Kies een contactpersoon</label>
                                <div className="lighter mb-2">
                                    Hier zijn alleen de personen koppelbaar welke zijn voorzien van voorletters, voornaam, achternaam en email.
                                </div>
                                <select name="eol_person_selected" className="form-control" onChange={this.changeContactPerson} value={this.state.eol_person_selected}>
                                    <option value="">{this.state.eol_persons_loading ? "Contactpersonen laden..." : "Kies een contactpersoon"}</option>
                                    {eolPersonsContent}
                                </select>
                                <div
                                    className={classNames("lighter", "mt-2", "mb-2", {
                                        "d-none": this.state.eol_person_selected == "" || this.state.eol_person_selected == false
                                    })}
                                >
                                    <a href={eolPersonLink} target="_blank">
                                        Beheer deze persoon in Exact Online
                                    </a>
                                    <span className="float-right">
                                        {this.state.eol_persons_loading ? "Laden..." : false}
                                        <i
                                            className={classNames("fa", "fa-refresh", "hoverable", { "fa-spin": this.state.eol_persons_loading })}
                                            onClick={this.addContactPerson}
                                        ></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        {newContactPersonContent}
                    </form>
                </Dialog>

                <ConfirmDemoteTrainerContactDialog
                    contact={this.state.demoteTrainerContact}
                    trainerName={this.state.name}
                    onClose={() => this.setState({ demoteTrainerContact: null })}
                    onConfirm={() => {
                        this.demoteItem(this.state.demoteTrainerContact).then(() => {
                            this.setState({ demoteTrainerContact: null });
                        });
                    }}
                />

                <ConfirmDeleteTrainerContactDialog
                    contact={this.state.deleteTrainerContact}
                    authorizedUsers={this.state.connected_users}
                    trainerName={this.state.name}
                    onClose={() => this.setState({ deleteTrainerContact: null })}
                    onConfirm={({ replacementUser }) => {
                        this.deleteItem(this.state.deleteTrainerContact, replacementUser).then(() => {
                            this.setState({ deleteTrainerContact: null });
                        });
                    }}
                />
            </div>
        );
    }
}

function ConfirmDemoteTrainerContactDialog({ contact, trainerName, onClose, onConfirm, ...props }) {
    return (
        <Dialog
            title="Contactpersoon ontkoppelen"
            visible={!!contact}
            onClose={onClose}
            footer={[
                <button key="cancel" className="btn btn-link" onClick={(e) => onClose()}>
                    Annuleren
                </button>,
                <button key="confirm" className="btn btn-primary" onClick={(e) => onConfirm()}>
                    Ja, ontkoppel deze contactpersoon
                </button>
            ]}
            {...props}
        >
            <p>
                Weet je zeker dat je {contact?.full_name} geen contactpersoon meer wilt laten zijn voor {trainerName}? De contactpersoon zal nog als instructeur gekoppeld
                blijven.
            </p>
        </Dialog>
    );
}

function ConfirmDeleteTrainerContactDialog({ contact, authorizedUsers, trainerName, onClose, onConfirm, ...props }) {
    const [replacementUser, setReplacementUser] = React.useState("");

    return (
        <Dialog
            title="Instructeur ontkoppelen"
            visible={!!contact}
            onClose={onClose}
            footer={[
                <button key="cancel" className="btn btn-link" onClick={(e) => onClose()}>
                    Annuleren
                </button>,
                <button key="confirm" className="btn btn-primary" onClick={(e) => onConfirm(replacementUser ? replacementUser.value : null)}>
                    Ja, ontkoppel deze contactpersoon
                </button>
            ]}
            {...props}
        >
            <p>
                Weet je zeker dat je {contact?.full_name} wilt ontkoppelen van {trainerName}?
            </p>

            <div>
                <label htmlFor="replacement-user">Wie gaat {contact?.full_name} vervangen?</label>
                <SelectNew
                    id="replacement-user"
                    value={replacementUser}
                    options={[
                        {
                            label: "Geen vervanging",
                            value: ""
                        },
                        {
                            label: "Contactpersonen",
                            options: authorizedUsers.map((user) => ({ value: user.uuid, label: user.full_name }))
                        }
                    ]}
                    onChange={setReplacementUser}
                />
            </div>
        </Dialog>
    );
}
